import React, { useEffect, useState } from "react";
import { BiSolidVideoPlus } from "react-icons/bi";
import { LuFileCheck2 } from "react-icons/lu";
import { Modal, message, Button, Select, Flex, Spin } from "antd";
import dayjs from "dayjs";
import ConsultationService from "../../../Services/ConsultationService";
import { EyeOutlined } from "@ant-design/icons";
import nodatafound from "../../../Assets/Images/Svg/nodatafound.svg";

function DigitalECG(props) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("live");
  const [ecgList, setEcgList] = useState([]);
  const [ecgUrl, setEcgUrl] = useState("");
  const [selectedDate, setSelectedDate] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    getEcg();
  }, [props.patientDetails]);

  const getEcg = async () => {
    if (props.patientDetails && props.patientDetails.patientId) {
      setIsLoading(true);
      const payload = {
        patientId: props.patientDetails.patientId,
        status: 1,
      };
      try {
        const res = await ConsultationService.fetchECGgraph(payload);
        if (Array.isArray(res.data) && res.data.length > 0) {
          setEcgList(res.data);
          setSelectedDate(res.data[0].uploadedDateTime);
        } else {
          setEcgList([]);
          setEcgUrl("");
          setSelectedDate(null);
        }
      } catch (e) {
        setIsLoading(false);
        setEcgList([]);
        setEcgUrl("");
        message.error("Failed to fetch ECG graphs.");
      } finally {
        setIsLoading(false);
      }
    }
  };

  const showModal = () => setIsModalOpen(true);
  const handleCancel = () => setIsModalOpen(false);

  const handleTabSwitch = (tab) => {
    setActiveTab(tab);

    if (ecgList.length > 0) {
      setEcgUrl(ecgList[0].resultDocumentName);
      setSelectedDate(ecgList[0].uploadedDateTime);
    }
  };

  const handleDateSelect = (value) => {
    setSelectedDate(value);
    const selectedEcg = ecgList.find((item) => item.uploadedDateTime === value);
    if (selectedEcg) {
      setEcgUrl(selectedEcg.resultDocumentName);
    }
  };

  const handleOpenGraphModal = (url) => {
    setEcgUrl(url);
    setIsModalOpen(true);
  };

  return (
    <div className="h-full overflow-x-scroll bg-white p-1">
      <div className="flex gap-2 my-2 cursor-pointer items-center">
        {/* <span
          onClick={() => handleTabSwitch("live")}
          className={`flex gap-2 rounded-full px-2 justify-center items-center ${
            activeTab === "live" ? "bg-[#FFD9D9]" : ""
          }`}
        >
          <BiSolidVideoPlus className="text-[#FF4949] w-6 h-6" />
          <span>Live Streaming</span>
        </span> */}

        <span
          onClick={() => handleTabSwitch("saved")}
          className={`flex gap-2 rounded-full px-2 justify-center items-center ${
            activeTab ? "bg-[#FFD9D9]" : ""
          }`}
        >
          <LuFileCheck2 />
          <span>Saved Graphs</span>
        </span>

        {ecgList.length > 0 && (
          <span className="text-sm text-gray-500 flex gap-2 items-center">
            {/* ✅ ECG Date Dropdown */}
            <Select
              style={{ width: 180 }}
              value={selectedDate}
              onChange={handleDateSelect}
              placeholder="Select Date"
            >
              {ecgList.map((item) => (
                <Select.Option key={item.id} value={item.uploadedDateTime}>
                  {dayjs(item.uploadedDateTime).format("DD/MM/YYYY HH:mm")}
                </Select.Option>
              ))}
            </Select>
          </span>
        )}
      </div>

      {/* ECG Display */}
      <div className="w-full h-[250px] overflow-y-scroll">
        {isLoading && ecgList?.length === 0 ? (
          <div className="flex items-center justify-center mt-[10%]">
            <Flex align="center" gap="middle">
              <Spin size="large" tip="Loading" />
            </Flex>
          </div>
        ) : ecgList?.length === 0 ? (
          <div className="flex flex-col items-center justify-center">
            <img src={nodatafound} alt="nodatafound" className="h-56 w-56" />
          </div>
        ) : (
          ecgList.map((item) => {
            const file = item?.resultDocumentName;
            if (!file) return item;
            let finalUrl;
            if (file?.startsWith("http") || file?.startsWith("https")) {
              finalUrl = file;
            } else {
              finalUrl = process.env.REACT_APP_IMAGE_URL + file;
            }

            return (
              <div className="w-full flex justify-between items-center p-3 px-6 border rounded-lg">
                <p className="text-base font-medium">{item?.labTestName}</p>
                <p className="text-base font-medium">
                  {item?.uploadedDateTime}
                </p>
                <a href={finalUrl} target="_blank" rel="noopener noreferrer">
                  <EyeOutlined
                    title="View Document"
                    className="text-[#189FAA] cursor-pointer text-lg"
                  />
                </a>
              </div>
            );
          })
        )}
      </div>

      <Modal
        title="ECG"
        open={isModalOpen}
        onCancel={handleCancel}
        footer={null}
        width={1200}
        height={1200}
      >
        <div style={{ width: "100%" }}>
          <iframe
            src={ecgUrl}
            title="ECG Modal Graph"
            style={{
              width: "100%",
              height: "800px",
              border: "1px solid #e5e7eb",
              borderRadius: "8px",
              display: "block",
            }}
            frameBorder="0"
            allowFullScreen
          />
        </div>
      </Modal>
    </div>
  );
}

export default DigitalECG;
